document.addEventListener('DOMContentLoaded', function () {
  import('@splidejs/splide').then((Splide) => {
    import('@splidejs/splide-extension-video').then(({ Video }) => {
      const elementsWithSplideClass = document.getElementsByClassName('splide');
      for (const element of elementsWithSplideClass) {
        const splideInstance = new Splide.default(element);
        splideInstance.mount({ Video });
      }
    });
  });
});
